import { Apple, Play } from "lucide-react";

const Badge = ({ icon, small, big, testId }) => (
  <div className="group relative">
    <button
      type="button"
      disabled
      aria-disabled="true"
      aria-describedby={`${testId}-tip`}
      data-testid={testId}
      className="flex items-center gap-3 rounded-xl border border-white/10 bg-white/5 px-4 py-2.5 text-left cursor-not-allowed opacity-80 select-none min-w-[176px] transition-[opacity,transform,border-color] duration-300 group-hover:opacity-100 group-hover:border-[var(--clinical)]/40"
    >
      <span className="text-white">{icon}</span>
      <span className="flex flex-col leading-tight">
        <span className="text-[10px] font-mono uppercase tracking-[0.18em] text-[#b7c2d4]">{small}</span>
        <span className="font-display text-base font-bold text-white">{big}</span>
      </span>
    </button>
    <span className="pointer-events-none absolute -top-2.5 -right-2 rounded-full bg-gradient-to-r from-[#1f8fff] to-[#0b3e86] text-white font-mono text-[10px] font-semibold uppercase tracking-wider px-2 py-0.5 shadow-[0_0_16px_rgba(77,170,255,0.45)]">
      Coming soon
    </span>
    <span
      id={`${testId}-tip`}
      role="tooltip"
      className="pointer-events-none absolute left-1/2 -translate-x-1/2 top-full mt-2 whitespace-nowrap rounded-md bg-[var(--electric)] px-3 py-1.5 text-xs font-medium text-white opacity-0 translate-y-1 transition-[opacity,transform] duration-300 group-hover:opacity-100 group-hover:translate-y-0"
    >
      Currently in internal testing
    </span>
  </div>
);

export const StoreBadges = () => (
  <div className="flex flex-wrap gap-4" data-testid="store-badges">
    <Badge icon={<Apple size={26} strokeWidth={1.75} />} small="Download on the" big="App Store" testId="store-badge-app-store" />
    <Badge icon={<Play size={24} strokeWidth={1.75} fill="currentColor" />} small="Get it on" big="Google Play" testId="store-badge-google-play" />
  </div>
);
